import { z } from 'zod';
export const meetingStatusSchema = z.enum(['scheduled', 'canceled']);
/** Date-range query, not paginated — a calendar view requests one
 * month/week window at a time, which is bounded regardless of tenant
 * size (unlike a list page a user can page through indefinitely). */
export const listMeetingsQuerySchema = z.object({
    from: z.string().datetime(),
    to: z.string().datetime(),
    leadId: z.string().uuid().optional(),
});
export const meetingResponseSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    startTime: z.string().datetime(),
    endTime: z.string().datetime().nullable(),
    location: z.string().nullable(),
    status: meetingStatusSchema,
    inviteeEmail: z.string(),
    inviteeName: z.string().nullable(),
    leadId: z.string().uuid().nullable(),
    contactId: z.string().uuid().nullable(),
    owner: z.object({ id: z.string().uuid(), displayName: z.string() }).nullable(),
});
//# sourceMappingURL=schemas.js.map